import { getAllGenericModelList, getAllModelListProducts, 
	getAllCotscoProdInventory, getAllGenericProdInventory,
	getGenericProdInventoryByCustomer, getGenericModelListByCustomer 
} from '../services/CatalogsService'
import { useState, useEffect } from 'react'
import TableContent from './TableContent'
import { useSearch } from '../context/KeywordSearchContext'
import { useLocation } from 'react-router-dom';
import { Typography } from '@mui/material';

export default function ProductsModelList() {
    const [offset, setOffset] = useState(0)
	const [products, setProducts] = useState([])
	const[pageSize, setPageSize] = useState(0);
    const [, setIsLoading] = useState(true)
    const [, setMessage] = useState("")
	let token = localStorage.getItem("site");
	const location = useLocation();
	const { pathname } = location;
	const [title, setTitle] = useState("")

	const { keyword,  customer } = useSearch()
	
	const handleChange = (event, value) => {
    	setOffset(value - 1)
    }
	const fetchData = async () => {
		let response = null;		
		try {
			switch (pathname){
				case "/dashboard/products/CatGeneric": 
					setTitle("GENERIC MODEL LIST")
					if (customer !== null && customer !== ""){
						response = await getGenericModelListByCustomer(token, offset, 10, keyword, customer)
					} 
					else{
						response = await getAllGenericModelList(token, offset, 10, keyword)
					}					
					break;
				case "/dashboard/products/CotscoProd":
					setTitle("CotscoProd")
					response = await getAllCotscoProdInventory(token, offset, 10, keyword)
					break;
				case "/dashboard/products/GenericProd":
					setTitle("GenericProd")
					if (customer !== null && customer !== "") {
						response = await getGenericProdInventoryByCustomer(token, offset, 10, keyword, customer)
					}
					else {
						response = await getAllGenericProdInventory(token, offset, 10, keyword)
					}					
					break;		
				default:
					setTitle("PRODUCTS")
					response = await getAllModelListProducts(token, offset, 10, keyword)
			}			
			setProducts(response.data.content)
			setMessage(response.data.message)
			setPageSize(response.data.totalPages)
			setIsLoading(false)
		} catch (err) {
			setProducts([])
			setMessage()
		}
	}

	useEffect(()=>{
        fetchData()
	}, [pathname, offset, keyword, customer])	


	return (
		<TableContent
			offset={offset}
			handleChange={handleChange}
			pageSize={pageSize}
			products={products}
			fetchData={fetchData}
			title={title}
		/>
	) 
}
